<template>
  <img src="/assets/images/spinner.svg" />
</template>